document.addEventListener("DOMContentLoaded",()=>{

const minus=document.querySelector(".qty-minus");
const plus=document.querySelector(".qty-plus");
const qty=document.querySelector(".mp-qty input");

if(minus){

minus.onclick=()=>{

if(qty.value>1){

qty.value--;

}

}

}

if(plus){

plus.onclick=()=>{

qty.value++;

}

}

});


/*==========================
ACCORDION
==========================*/

document.addEventListener("DOMContentLoaded", function () {

    const items = document.querySelectorAll(".mp-item");

    items.forEach(item => {

        const trigger = item.querySelector(".mp-trigger");

        trigger.addEventListener("click", function (e) {

            e.preventDefault();
            e.stopPropagation();

            const isOpen = item.classList.contains("active");

            items.forEach(i => {
                i.classList.remove("active");
                const content = i.querySelector(".mp-content");
                content.style.maxHeight = null;
            });

            if (!isOpen) {
                item.classList.add("active");
                const content = item.querySelector(".mp-content");
                content.style.maxHeight = content.scrollHeight + "px";
            }

        });

    });

});